import { formatRegionalUserDisplayName, getUserDisplayData } from '@modules/utils/user-display-data'

import type { UserStore } from './user.type'

export const selectCurrentUser = (state: UserStore) => state.currentUser

export const selectCurrentUserEmail = (state: UserStore) =>
  state.currentUser?.regionalData?.userEmail?.trim() || state.currentUser?.profile?.email?.trim() || null

export const selectCurrentUserDisplayName = (state: UserStore) => {
  const user = state.currentUser
  if (!user) {
    return ''
  }

  const profileName = user.profile?.name || user.profile?.nickname || ''
  return formatRegionalUserDisplayName(user.regionalData ?? undefined) || profileName
}

export const selectCurrentUserRegionalId = (state: UserStore) =>
  state.currentUser?.regionalData?.userId ?? state.currentUser?.regionalIdentity?.userUid ?? null

export const selectCurrentUserAvatarUrl = (state: UserStore) => {
  const avatarUrl = state.currentUser?.regionalData?.avatarUrl?.trim()
  return avatarUrl || null
}

export const selectCurrentUserInitialsSource = (state: UserStore) => {
  const user = state.currentUser
  if (!user) {
    return ''
  }

  const { fullName, email } = getUserDisplayData(user)
  if (fullName && fullName !== 'User') {
    return fullName
  }

  return email
}

export const selectCurrentUserDisplayData = (state: UserStore) => getUserDisplayData(state.currentUser)

export const selectInvitations = (state: UserStore) => state.invitations

export const selectUserFetchState = (state: UserStore) => ({
  loading: state.loading,
  error: state.error,
})
